import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      // eslint-disable-next-line no-console
      console.error("App crashed:", error, info);
    }
  }
  reset = () => {
    this.setState({ hasError: false, error: null });
  };
  render() {
    if (this.state.hasError) {
      return (
        <div className="min-h-screen flex items-center justify-center p-6 bg-slate-50">
          <div className="max-w-md w-full card-outline p-6 text-center">
            <div className="font-display text-xl font-bold mb-2">Algo deu errado</div>
            <p className="text-sm text-slate-600 mb-4">
              Ocorreu um erro inesperado. Tente novamente ou recarregue a página.
            </p>
            {this.state.error?.message && (
              <pre className="text-xs text-rose-600 bg-rose-50 p-2 rounded mb-4 overflow-auto max-h-32">
                {String(this.state.error.message)}
              </pre>
            )}
            <div className="flex gap-2 justify-center">
              <button onClick={this.reset}
                className="px-4 py-2 rounded-lg border border-slate-300 text-sm hover:bg-slate-100"
                data-testid="error-retry-btn">
                Tentar de novo
              </button>
              <button onClick={() => window.location.reload()}
                className="px-4 py-2 rounded-lg bg-blue-600 text-white text-sm hover:bg-blue-700"
                data-testid="error-reload-btn">
                Recarregar
              </button>
            </div>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
